import styled from "styled-components";

export const Section = styled.section`
  margin-top: 4rem;
  padding-top: 4rem;
  padding-bottom: 4rem;
  background: linear-gradient(
    to right,
    rgba(73, 90, 255, 0.9),
    rgba(10, 206, 254, 0.9)
  );
  color: white;

  @media (min-width: 768px) {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;

  @media (min-width: 640px) {
    max-width: 640px;
  }

  @media (min-width: 768px) {
    max-width: 768px;
  }

  @media (min-width: 1024px) {
    max-width: 1024px;
  }

  @media (min-width: 1280px) {
    max-width: 1280px;
  }

  @media (min-width: 1536px) {
    max-width: 1536px;
  }
`;

export const Title = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 1.5rem;
  animation: fadeIn 0.5s ease-in forwards;

  @media (min-width: 768px) {
    font-size: 2.25rem;
  }
`;

export const Description = styled.p`
  font-size: 1.125rem;
  margin-bottom: 2.5rem;
  text-align: center;
  max-width: 40rem;
  margin-left: auto;
  margin-right: auto;
  animation: fadeIn 0.5s ease-in 0.15s forwards;
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  animation: fadeIn 0.5s ease-in 0.3s forwards;
  text-decoration: none;

  a {
    text-decoration: none;
  }

  @media (min-width: 640px) {
    flex-direction: row;
  }
`;

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  padding: 1rem 2rem;
  border-radius: 9999px;
  transition: background 0.3s ease;

  &.primary {
    background-color: white;
    border: none;
    color: ${({ theme }) => theme.colors.primary[3]};
    &:hover {
      background-color: #e5e7eb;
    }
  }

  &.outline {
    border: 1px solid white;
    color: white;
    background: transparent;
    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
`;

export const Disclaimer = styled.p`
  margin-top: 2rem;
  font-size: 0.875rem;
  animation: fadeIn 0.5s ease-in 0.45s forwards;
  text-align: center;
`;
